import { createSelector } from 'reselect';

export const globalSiteStateSelector = state => state.globalSite;

export const genericErrorSelector = createSelector(
  globalSiteStateSelector,
  globalSite => globalSite.genericError
);
